module.exports = __webpack_public_path__ + "static/media/8D.5f81e325.svg";